import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

/**
 * Frame for a full-height page a signed-out visitor can read.
 *
 * The signed-in app puts its pages inside AppLayout's icon rail. That rail is
 * wrong here — every icon on it leads somewhere this reader cannot go — so
 * this gives the same shape with the one link they can use instead.
 *
 * The height chain matters: PageShell inside is `h-full` with its own inner
 * scroll, so the bar has to be `shrink-0` and the slot `min-h-0 flex-1`, the
 * same arrangement AppLayout uses. Without `min-h-0` the child's overflow
 * would push the page instead of scrolling inside it.
 */
export function PublicShell({ children }: { children: ReactNode }): React.JSX.Element {
  return (
    <div className="flex h-full flex-col">
      <header className="flex shrink-0 items-center justify-between gap-3 border-b border-slate-200 bg-white px-4 py-2.5 dark:border-slate-800 dark:bg-slate-900">
        <Link to="/login" className="flex items-center gap-2">
          <img src="/logo-96.png" alt="" width={28} height={28} className="h-7 w-7" />
          <span className="text-sm font-semibold text-slate-900 dark:text-slate-50">LeadGab</span>
        </Link>

        <Link to="/login" className="lg-btn-secondary">
          Sign in
        </Link>
      </header>

      <div className="min-h-0 flex-1">{children}</div>
    </div>
  );
}
